import _map from "lodash/map";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import EmptyRow from "./EmptyRow";

var DataTableBody =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTableBody, _Component);

  function DataTableBody(props) {
    var _this;

    _classCallCheck(this, DataTableBody);

    _this = _possibleConstructorReturn(this, (DataTableBody.__proto__ || Object.getPrototypeOf(DataTableBody)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "getNumberOfColumns", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            displayPreferences = _this$props.displayPreferences,
            renderActions = _this$props.renderActions; // Add one extra column for trailing <th>

        var numberOfColumns = displayPreferences.filter(function (r) {
          return r.display;
        }).length + 1;

        if (renderActions && numberOfColumns > 1) {
          numberOfColumns++;
        }

        return numberOfColumns;
      }
    });
    _this.isBulk = _this.isBulk.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DataTableBody, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this; // Check specifically on these props
      // because we receive a changing prop from react-scrollbars


      return ['data', 'displayPreferences', 'isLoading', 'checkable', 'multi', 'rowSelections', 'shouldRenderPreviewIcon', 'allowSelectionOnRowClick'].some(function (prop) {
        return _this2.props[prop] !== nextProps[prop];
      });
    }
  }, {
    key: "isBulk",
    value: function isBulk() {
      var _props = this.props,
          multi = _props.multi,
          rowSelections = _props.rowSelections;
      return multi && Object.values(rowSelections).reduce(function (total, isSelected) {
        return total + isSelected;
      }) > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          data = _props2.data,
          _props2$isLoading = _props2.isLoading,
          isLoading = _props2$isLoading === void 0 ? true : _props2$isLoading,
          _props2$showLoading = _props2.showLoading,
          showLoading = _props2$showLoading === void 0 ? true : _props2$showLoading,
          rowRenderer = _props2.rowRenderer,
          emptyRowText = _props2.emptyRowText,
          getTableRef = _props2.getTableRef;
      var numberOfColumns = this.getNumberOfColumns();

      if (isLoading && showLoading) {
        return React.createElement("tbody", null, React.createElement(EmptyRow, {
          text: "Loading ... ",
          colSpan: numberOfColumns
        }));
      }

      if (!data.length) {
        return React.createElement("tbody", null, React.createElement(EmptyRow, {
          text: emptyRowText,
          colSpan: numberOfColumns + 1
        }));
      } // numberOfColumns === 1 means that there is only empty trailing column


      if (numberOfColumns === 1) {
        return React.createElement("tbody", null, React.createElement(EmptyRow, {
          text: "Please select some columns for displaying",
          colSpan: numberOfColumns + 2
        }));
      }

      return React.createElement("tbody", null, _map(data, function (item, idx) {
        return rowRenderer(_this3.props, item, idx, _this3.isBulk, getTableRef);
      }));
    }
  }]);

  return DataTableBody;
}(Component);

Object.defineProperty(DataTableBody, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: 'TableBody'
});
export { DataTableBody as default };